module.exports = __webpack_public_path__ + "8cd5300218d2c9426cc37f5d6a1963c4.svg";